import { render, staticRenderFns } from "./NumberFollowers.vue?vue&type=template&id=02f443aa&scoped=true"
import script from "./NumberFollowers.vue?vue&type=script&lang=js"
export * from "./NumberFollowers.vue?vue&type=script&lang=js"
import style0 from "./NumberFollowers.vue?vue&type=style&index=0&id=02f443aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f443aa",
  null
  
)

export default component.exports